"use client";
import Image from "next/image";
import React from "react";
import cx from "classnames";
import helper from "utils/helper";

interface ImageProps {
  wrapClassName?: string;
  className?: string;
  src: string;
  alt?: string;
  objectFit?: string;
  layout?: string;
  aspectRatio?: number;
  isRelative?: boolean;
  defaultImage?: React.ReactNode;
  priority?: boolean;
  sizes?: string;
  quality?: number;
  // onLoad?: (e: unknown) => void;
  [key: string]: unknown;
}

export default function CustomImage({
  wrapClassName,
  className,
  src,
  alt = "lookme website",
  objectFit = "cover",
  layout = "fill",
  aspectRatio,
  isRelative = false,
  defaultImage,
  // Trước đây mặc định priority=true cho MỌI ảnh (card rail, thumbnail, footer…)
  // → browser tải "high priority" hàng chục ảnh dưới màn hình đầu, tranh băng
  // thông/main-thread với ảnh LCP thật → TBT tăng, +800KiB payload trang chủ
  // (review vòng 3, góc 7). Giờ priority mặc định false — chỉ ảnh LCP (hero,
  // banner đầu trang) mới cần truyền priority={true} tường minh.
  priority = false,
  // fill=true mà không set sizes thì Next mặc định sizes="100vw" → card nhỏ
  // (150-262px) vẫn tải ảnh full viewport width ở DPR cao → quá khổ. Mặc định
  // "100vw" vẫn giữ cho nơi chưa truyền sizes (an toàn), nhưng khuyến khích
  // caller truyền sizes đúng kích thước card hiển thị.
  sizes = "100vw",
  quality = 75,
  // onLoad,
  ...props
}: ImageProps) {
  const [imageSrc, $imageSrc] = React.useState(() => {
    return isRelative ? src : helper.imageUrl(src);
  });
  React.useEffect(() => {
    $imageSrc(isRelative ? src : helper.imageUrl(src));
  }, [src]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={cx("relative", wrapClassName)}>
      {!!imageSrc && (
        <Image
          className={cx("w-full h-full", className)}
          style={{
            aspectRatio,
            objectFit: objectFit as
              | "cover"
              | "contain"
              | "fill"
              | "none"
              | "scale-down",
          }}
          src={imageSrc}
          alt={alt || "lookme website"}
          priority={priority}
          quality={quality}
          sizes={layout === "fill" ? sizes : undefined}
          fill={layout === "fill"}
          onLoad={() => {
            // console.log("Hình ảnh đã load thành công!");
          }}
          onError={() => {
            // console.log("Lỗi khi load hình ảnh!");

            $imageSrc("");
          }}
          onLoadingComplete={() => {
            // Callback này chạy khi hình ảnh load hoàn tất
            // console.log("Load hoàn tất:", result);
          }}
          {...props}
        />
      )}
      {!imageSrc && (
        <div
          className="w-full h-full rounded-md bg-gray-200 flex items-center justify-center"
          {...props}
        >
          {defaultImage}
        </div>
      )}
    </div>
  );
}
